// packages/ui-kit/src/people/LeaveBadge.tsx
// C3F v18 — reference: design/system/components/people/LeaveBadge.{jsx,prompt.md}
import type { Leave } from "@praesto/shared-types";
import { Badge, type BadgeTone } from "../primitives/Badge.js";

const tones: Record<Leave["type"], BadgeTone> = {
  vacation: "success",
  permit: "info",
  sick: "danger",
  // Deliberately `info`, not `danger`: a statutory leave is not an illness,
  // and it should not read like one.
  leave: "info",
};

const labels: Record<Leave["type"], string> = {
  vacation: "Ferie",
  permit: "Permesso",
  sick: "Malattia",
  // Deliberately says only that the person is away, never why (see LeaveType).
  leave: "Congedo",
};

// DS Badge `dot`: 6px, solid, repeating the state ink.
const dotCls: Record<Leave["type"], string> = {
  vacation: "bg-success",
  permit: "bg-info",
  sick: "bg-danger",
  leave: "bg-info",
};

export function LeaveBadge({ leave }: { leave: Leave }) {
  return (
    <Badge
      tone={tones[leave.type]}
      variant="soft"
      size="sm"
      // Dates are reading units: they never wrap.
      className="whitespace-nowrap"
      iconLeft={<span aria-hidden className={`h-1.5 w-1.5 rounded-full ${dotCls[leave.type]}`} />}
      {...(leave.externalRef ? { title: `Importato da ${leave.externalRef.provider}` } : {})}
    >
      {labels[leave.type]} · {leave.startDate}→{leave.endDate}
      {leave.externalRef ? " · Importato" : ""}
    </Badge>
  );
}
